import { Box, Column, GridContainer, H2, Row, Typography } from '@vp/swan';
import RelatedIdeasLink from './RelatedIdeasLink';

interface RelatedIdeasProps {
    keyword?: string;
    relatedKeywords: RelatedKeywordData[];
    longName?: string;
}

export interface RelatedKeywordData {
    keyword: string;
    name: string;
    path: string;
}

const RelatedIdeas = ({ keyword, relatedKeywords, longName }: RelatedIdeasProps) => {
    const currentKeyword = keyword;

    const webPageStructuredData = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        relatedLink: relatedKeywords.map(({ path }) => path),
    };

    return (
        <>
            <H2 marginBottom="to-actions" fontSkin="title-section">
                {longName
                    ? `Discover more ideas related to ${longName} logos`
                    : 'Discover a world of logos'}
            </H2>
            <Typography fontSkin="body-standard" marginBottom="between-subsections">
                {`Get inspired and explore thousands of ${longName ? longName + ' ' : ''}logo ideas that our happy customers have created.`}
            </Typography>
            <GridContainer>
                <Row>
                    {relatedKeywords.map(({ keyword, name }) => {
                        return (
                            <Column
                                key={keyword}
                                padding={0}
                                span={4}
                                spanXl={2}
                                spanLg={3}
                                spanMd={4}
                                spanSm={4}
                                spanXs={12}
                            >
                                <Box
                                    marginTop={{
                                        xs: 'between-actions',
                                        sm: 3,
                                        md: 5,
                                        lg: 5,
                                        xl: 5,
                                    }}
                                    marginX={{ xs: 0, sm: 2, md: 3, lg: 3, xl: 3 }}
                                >
                                    <RelatedIdeasLink
                                        currentKeyword={currentKeyword}
                                        keyword={keyword}
                                        name={name}
                                    />
                                </Box>
                            </Column>
                        );
                    })}
                    <script
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                            __html: JSON.stringify(webPageStructuredData),
                        }}
                    />
                </Row>
            </GridContainer>
        </>
    );
};

export default RelatedIdeas;
